import { UnionNoticeBoard } from '../shared/UnionNoticeBoard.jsx';

export function MobileUnionNotices({ onNavigate }) {
  return <UnionNoticeBoard mobile onNavigate={onNavigate} />;
}
